import React from 'react';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function ExternalLink({ href, children }) {
  return (
    <Link href={href} target="_blank" rel="noopener">
      {children}
      <OpenInNewIcon sx={{ fontSize: 16, ml: 0.2, verticalAlign: 'middle' }} />
    </Link>
  );
}
